export interface ICheckEmailReducer {
  isEmailExist: boolean,
  isEmailConfirmed: boolean
}
export const checkEmailInitialState:ICheckEmailReducer = {
  isEmailExist: false,
  isEmailConfirmed: false
};
